import { Box, Card, Link, Text } from '@nimbus-ds/components';
import { generatePath, Link as LinkRoute } from 'react-router-dom';
import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { ExternalLink, useResponsive } from 'commons/components';
import { useGetCountry } from 'domains/Auth/hooks';
import { useGetEcommerceNaPraticaQuery } from 'domains/Dashboard/dashboardApi';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { trackingEnpClickNewOnboarding202411 } from 'domains/Dashboard/tracking';
import { partnersAppsRoutes } from 'domains/PartnersApps';
import ImageEcommerceEnAccion from './ecommerce-en-acción.png';
import ImageEcommerceNaPratica from './enp-image-2.png';

const ECOMMERCE_APP_ID = '1006';
const BREAKPOINT_MD_WIDTH = 672;

const MX_ENP_URL =
  'https://www.youtube.com/watch?v=bbZUJ4GEQzc&list=PL5kR_3HfjG5aHT24xcKvyhqFzWz4HcOdt';

const BR_ENP_URL = 'https://youtu.be/4nUpfLfSK_E?si=5Xt-ZLq9f3WrDRvT';

function NewEcommerceNaPraticaCard() {
  const t = useTranslationDashboard('improveStore_202411.e-commerce');
  const country = useGetCountry();

  const { data, isLoading } = useGetEcommerceNaPraticaQuery();
  const { isMobile: isMobileResponsive } = useResponsive(BREAKPOINT_MD_WIDTH);

  if (isLoading) return null;

  return (
    <ShowByCountry allowedCountries={[Country.BR, Country.MX]}>
      <Box>
        <Card>
          <Card.Body>
            <Box
              display="flex"
              flexDirection={{
                lg: 'row',
                md: 'row',
                xs: 'column',
              }}
              gap="4"
            >
              <img
                alt="ecommercenapratica-img"
                src={
                  country === Country.MX
                    ? ImageEcommerceEnAccion
                    : ImageEcommerceNaPratica
                }
                style={
                  isMobileResponsive
                    ? {
                        width: '100%',
                        aspectRatio: '33 / 14',
                        borderRadius: '8px',
                        objectFit: 'cover',
                      }
                    : {
                        height: '82px',
                        width: '188px',
                        borderRadius: '8px',
                        objectFit: 'cover',
                      }
                }
              />
              <Box
                display="flex"
                flexDirection="column"
                gap="1"
                justifyContent="center"
                maxWidth="703px"
              >
                <Box display="flex" flexDirection="column" gap="1">
                  <Text
                    fontSize="caption"
                    color="neutral-textHigh"
                    lineHeight="caption"
                  >
                    {t('title')}
                  </Text>
                  <Text
                    fontSize="caption"
                    color="neutral-textLow"
                    lineHeight="caption"
                  >
                    {t('description')}
                  </Text>
                </Box>
                {country === Country.BR && !data?.hasInstalled && (
                  <Link
                    textDecoration="none"
                    fontSize="caption"
                    as={LinkRoute}
                    to={generatePath(partnersAppsRoutes.authorization, {
                      id: ECOMMERCE_APP_ID,
                    })}
                    appearance="primary"
                    onClick={trackingEnpClickNewOnboarding202411(
                      'primeira-venta',
                    )}
                  >
                    {t('linkText')}
                  </Link>
                )}
                {(country === Country.MX || data?.hasInstalled) && (
                  <ExternalLink
                    textDecoration="none"
                    fontSize="caption"
                    appearance="primary"
                    href={country === Country.MX ? MX_ENP_URL : BR_ENP_URL}
                  >
                    {t('linkText')}
                  </ExternalLink>
                )}
              </Box>
            </Box>
          </Card.Body>
        </Card>
      </Box>
    </ShowByCountry>
  );
}

export default NewEcommerceNaPraticaCard;
